import React from 'react';
import { usePriceFlash } from '@/hooks/usePriceFlash';

interface PriceDisplayWithFlashProps {
    price: number | null | undefined;
    className?: string;
    formatPrice?: (price: number) => string;
    flashDuration?: number;
}

/**
 * Component that displays a price with a flash effect when it changes
 * - Green flash if price increased
 * - Red flash if price decreased
 * - Flash lasts for 500ms by default
 */
const PriceDisplayWithFlash: React.FC<PriceDisplayWithFlashProps> = ({
    price,
    className = '',
    formatPrice,
    flashDuration = 500,
}) => {
    const { flashClassName, direction } = usePriceFlash(price, flashDuration);

    if (price === null || price === undefined || price <= 0) {
        return <div className={className}>--</div>;
    }

    const displayPrice = formatPrice ? formatPrice(price) : price.toFixed(5);

    return (
        <div className={`font-semibold transition-all duration-300 ${flashClassName} ${className}`}>
            {displayPrice}
        </div>
    );
};

export default PriceDisplayWithFlash;
